import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { XeroTenantConnection } from '../types/xero';

export type XeroExchangeResponse = {
    connections: XeroTenantConnection[];
    xeroUserId: string;
};

async function exchangeCode(code: string): Promise<XeroExchangeResponse> {
    const { data } = await api.post(`/xero/exchange`, { code });
    return data;
}

export function useExchangeXeroCode(): UseMutationResult<XeroExchangeResponse, AxiosError, string, unknown> {
    return useMutation(exchangeCode);
}
